import React from 'react'
import { OurAppsBreadcrumbBar } from '../../../our-apps-breadcrumb-bar'
import CallToActionSection from '../../../call-to-action-section'
import { FeatureSection } from './feature-section'
import { AboutSection } from './about-section'
import { HaulerProductImage } from '../../../product-image/hauler-product-image'

export default function Hauler() {
  return (
    <>
      <OurAppsBreadcrumbBar title="Hauler" productImage={<HaulerProductImage />} />

      <AboutSection />

      <CallToActionSection />

      <FeatureSection />
    </>
  )
}
